// extracted by mini-css-extract-plugin
export default {"container":"Favorites_container__4EAAJ"};